import LecturerUserDataTable from './LecturerUserDataTable'
import {useTranslation} from 'react-i18next'
import UnAuthorized from 'app/custom/UnAuthorized'
import {useAuth} from '../core/Auth'

const LecturerUserList = () => {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()

  if (!hasPermission('users-list')) return <UnAuthorized />

  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{t('MENU.LECTURER_USERS')}</h3>
        </div>
      </div>
      <div className='card-body p-9'>
        <LecturerUserDataTable
          headers={[
            {
              headerName: t('GLOBAL.USERNAME'),
              sort: 'name',
            },
            {
              headerName: t('GLOBAL.NAME'),
              sort: 'username',
            },
            {
              headerName: t('PROFILE.EMAIL'),
              sort: 'email',
            },
            {
              headerName: t('GLOBAL.ACTION'),
              sort: 'action',
            },
          ]}
          columns={['name', 'username', 'email', 'action']}
        />
      </div>
    </div>
  )
}

export default LecturerUserList
